import { useState } from "react";
import { IMAGES } from "@/lib/site";
import { X, Expand } from "lucide-react";

// Only owner-provided images (no stock photos in the gallery per user request)
const galleryImages = [
  { src: IMAGES.heroDay, alt: "Homestay day view" },
  { src: IMAGES.heroLaptop, alt: "Homestay at night — wide view" },
  { src: IMAGES.heroMobile, alt: "Homestay evening lights" },
  { src: IMAGES.roomCouple, alt: "Couple & Family room" },
  { src: IMAGES.roomGroup, alt: "Group dormitory room" },
  { src: IMAGES.food1, alt: "Malnad banana-leaf thali" },
  { src: IMAGES.food2, alt: "Fresh dosa with chutneys" },
];

const Gallery = () => {
  const [active, setActive] = useState(null);

  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative py-24 md:py-32 bg-[#F8FAF7]"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="max-w-2xl reveal">
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-8 bg-[#D4AF37]" />
            <span className="text-[11px] tracking-[0.3em] uppercase text-[#D4AF37] font-medium">
              Gallery
            </span>
          </div>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl text-[#1B4332] leading-[1.05] tracking-tight">
            Moments at{" "}
            <span className="italic font-light">Navilukallu</span>
          </h2>
          <p className="mt-5 text-[#1A1A1A]/75 text-base md:text-lg">
            A glimpse of the rooms, the food, and the estate. More photos
            coming soon.
          </p>
        </div>

        <div className="mt-14 masonry columns-1 sm:columns-2 lg:columns-3">
          {galleryImages.map((g, i) => (
            <button
              type="button"
              key={g.src + i}
              onClick={() => setActive(g)}
              data-testid={`gallery-item-${i}`}
              className="reveal group relative w-full block rounded-2xl overflow-hidden bg-[#1B4332] focus:outline-none focus:ring-2 focus:ring-[#D4AF37]"
              style={{ animationDelay: `${i * 0.04}s` }}
            >
              <img
                src={g.src}
                alt={g.alt}
                loading="lazy"
                decoding="async"
                className="w-full h-auto object-cover group-hover:scale-[1.04] transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-[#1B4332]/0 group-hover:bg-[#1B4332]/30 transition-colors flex items-center justify-center">
                <span className="opacity-0 group-hover:opacity-100 transition-opacity w-12 h-12 rounded-full bg-white/90 flex items-center justify-center text-[#1B4332]">
                  <Expand size={18} />
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>

      {active && (
        <div
          data-testid="gallery-lightbox"
          className="fixed inset-0 z-[60] bg-black/95 flex items-center justify-center p-4"
          onClick={() => setActive(null)}
        >
          <button
            type="button"
            data-testid="gallery-lightbox-close"
            className="absolute top-6 right-6 w-11 h-11 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center"
            onClick={(e) => {
              e.stopPropagation();
              setActive(null);
            }}
            aria-label="Close"
          >
            <X size={22} />
          </button>
          <img
            src={active.src}
            alt={active.alt}
            className="max-h-[85vh] max-w-[92vw] object-contain rounded-xl shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </section>
  );
};

export default Gallery;
